import React, {useState, useEffect} from 'react'
import './MyWorks.scss'
import { motion } from 'framer-motion'
import {AiFillEye, AiFillGithub, AiFillLeftCircle, AiFillRightCircle } from 'react-icons/ai'
import { client, urlFor } from '../../client'
import { AppWrap, MotionWrap } from '../../wrapper'
import { Link, useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'



const MyWorks = () => {

  const navigate = useNavigate()
  const [activeFilter, setActiveFilter] = useState("All")
  const [animateCard, setAnimateCard] = useState({y:0, opacity:1})
  const [works, setWorks] = useState([])
  const [filterWork, setFilterWork] = useState([])

  const [isMobile, setIsMobile] = useState(false)
  const [nNum, setNum] = useState(0)

  useEffect(() => {
    function handleResize() {
      
      if (window.innerWidth < 480) {
          setIsMobile(true)
      }else{
        setIsMobile(false)
      }
    }

    window.addEventListener('resize', handleResize);

    // Call handleResize initially to set the state correctly
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const query = '*[_type == "works"]'

    client.fetch(query)
    .then((data)=> {
      setWorks(data)
      setFilterWork(data)
    })
  }, [])
  
  const handleWorkFilter = (item) => {
    setNum(0)
    setActiveFilter(item)
    setAnimateCard([{y:100, opacity:0}])

    setTimeout(() => {
      setAnimateCard([{y:0, opacity:1}])

      if(item === 'All'){
        setFilterWork(works)
      }else{
        setFilterWork(works.filter((work) => work.tags.includes(item)))
      }
    }, 1000);
  }

  const navTo=(item)=>{
    navigate("/workdetails", {state:item})
  }

  return (
    <>
     <h2 
     style={{marginTop:"100px", paddingTop:'40px'}}
     className='head-text'>
       My <span>Creative</span> PortFolio
      </h2>

      <div>
      <div 
      style={{alignItems:'center', justifyContent:'center'}}
      className="app__work-filter">
        
        {['All', 'Android', 'IOS'].map((data, index)=>(
          <div key={index}
          
          onClick={()=> handleWorkFilter(data)}
          className={`app__work-filter-item app__flex p-text ${activeFilter === data ? 'item-active' : ''}`}>
            {data}
          </div>
          
        ))}
      </div>
      {isMobile?
        <motion.div 
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="appp__work-portfolio">
              
                {filterWork?.length>0 && (
                  <Link className="app__work-item app__flex" 
                 to={"/workdetails"}
                  >
                  <div className="app__work-img app__flex">
                    <img src={urlFor(filterWork[nNum]?.imgUrl)} alt={filterWork[nNum]?.name} />
                    <motion.div 
                    whileHover={{opacity: [0, 1]}}
                    transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5}}
                    className="app__work-hover app__flex">

                      <a href={filterWork[nNum]?.projectLink} target="_blank" rel="noreferrer">
                          <motion.div 
                          whileInView={{scale: [0, 1]}}
                          whileHover={{ scale: [1, 0.9]}}
                          transition={{duration:0.25}}
                          className="app__flex"
                          >
                            <AiFillEye />
                          </motion.div>
                        </a>

                        <a href={filterWork[nNum]?.projectLink} target="_blank" rel="noreferrer">
                          <motion.div 
                          whileInView={{scale: [0, 1]}}
                          whileHover={{ scale: [1, 0.9]}}
                          transition={{duration:0.25}}
                          className="app__flex"
                          >
                            <AiFillGithub />
                          </motion.div>
                        </a>
                    
                    </motion.div>
                  </div>
                  <div className="app__work-content app__flex">
                  <h4 className='bold-text'>{filterWork[nNum]?.title}</h4>
                    <div className="app__work-tag app__flex">
                    <p className='p-text'>{filterWork[nNum]?.tags?.length>0 ? filterWork[nNum]?.tags[0] : ""}</p>
                  </div>
                  </div>

                <div>
                  <AiFillLeftCircle size={40}
                  onClick={()=>{
                    if(nNum==0){
                      setNum(filterWork?.length-1)
                    }else{
                      setNum(nNum-1)
                    }
                  }}
                  />
                  <AiFillRightCircle size={40}
                  onClick={()=>{
                    if(nNum==filterWork?.length-1){
                      setNum(0)
                    }else{
                      setNum(nNum+1)
                    }
                  }}
                  />
                </div>
                  
              </Link>
                )}
            
            </motion.div>
          :

          <motion.div 
      animate={animateCard}
      transition={{ duration: 0.5, delayChildren: 0.5 }}
      className="app__work-portfolio">
            {filterWork.map((work, index)=>(
              <div className="app__work-item app__flex" key={index}
              onClick={()=>{navTo(work)}}
              >
                  <div className="app__work-img app__flex">
                    <img src={urlFor(work.imgUrl)} alt={work.name} />
                    <motion.div 
                    whileHover={{opacity: [0, 1]}}
                    transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5}}
                    className="app__work-hover app__flex">

                      <a href={work.projectLink} target="_blank" rel="noreferrer">
                          <motion.div 
                          whileInView={{scale: [0, 1]}}
                          whileHover={{ scale: [1, 0.9]}}
                          transition={{duration:0.25}}
                          className="app__flex"
                          >
                            <AiFillEye />
                          </motion.div>
                        </a>

                        <a href={work.projectLink} target="_blank" rel="noreferrer">
                          <motion.div 
                          whileInView={{scale: [0, 1]}}
                          whileHover={{ scale: [1, 0.9]}}
                          transition={{duration:0.25}}
                          className="app__flex"
                          >
                            <AiFillGithub />
                          </motion.div>
                        </a>
                    
                    </motion.div>
                  </div>
                  <div className="app__work-content app__flex">
                    <h4 className='bold-text'>{work.title}</h4>
                    <p className='p-text' style={{marginTop: 10}}>{work.description}</p>
                  
                    <div className="app__work-tag app__flex">
                    <p className='p-text'>{work?.tags?.length>0 ? work.tags[0] : ""}</p>
                  </div>
                  </div>

                  
              </div>
            ))}
          </motion.div>
    }
          
      </div>

    </>
  )
}

export default AppWrap(MotionWrap(MyWorks,'app__works'), 'work', 'app__primarybg')